import { takeLatest, call, put, select } from "redux-saga/effects";
import _ from "lodash";
import { unlockProject } from "../../../services/projects";
import { openSnackbar } from "../../_shared/snack-bar/snackbarActions";
import { errorOpenModal } from "../../_shared/modal/errorModalActions";
import * as actions from "../projectActions";
import { setData } from "../../projects/projectsActions";

const projectSelector = state => _.get(state, "projects.data");
const projectDetailsSelector = state => _.get(state, "projectDetails.data");

export default function* unlockProjectWatcher() {
  yield takeLatest(actions.UNLOCK, unlockProjectWorker);
}

export function* unlockProjectWorker(action) {
  let variables = {
    closing_id: action.closing_id,
  };
  try {
    const response = yield call(unlockProject, variables);
    yield call(success, response, action);
  } catch (error) {
    yield call(failure, error);
  }
}

export function* success(response, action) {
  const data = _.get(response, "data.unlockProject", {});
  if (data.Success == "true") {
    yield put(
      openSnackbar({
        message: "Project Active!",
        showCloseIcon: true,
      }),
    );

    if (action.projectOpen) {
      // Update the current project details in Redux
      let projectData = yield select(projectDetailsSelector);
      if (projectData && projectData.projectDetails) {
        yield put(actions.setData({
          ...projectData,
          projectDetails: {
            ...projectData.projectDetails,
            status_code: 1,
            status_code_desc: "Active",
            desk_audit_closing_actual_date: null,
          },
        }));
      }
    } else {
      let projects = yield select(projectSelector);
      let updateIndex = _.findKey(projects, { closing_id: action.closing_id });

      let projectEdited = projects[updateIndex];
      projectEdited.status_code_desc = "Active";

      if (updateIndex > -1) {
        projects.splice(updateIndex, 1);
      }
      projects.unshift(projectEdited);

      yield put(setData(projects));
    }
  }
}

export function* failure(error) {
  yield put(actions.error(error));
  yield put(
    errorOpenModal({
      title: "Project could not be unlocked",
      message: "An error occured while unlocking the Project",
    }),
  );
  return error;
}
